import { forwardRef } from 'react';
import {
  Snackbar,
  Alert as MuiAlert,
  Typography,
  Box
} from '@mui/material';
import {
  CheckCircleOutline,
  ErrorOutline,
  InfoOutlined,
  WarningAmber
} from '@mui/icons-material';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function NotificationSnackbar({
  open,
  onClose,
  message,
  description,
  severity = 'success',
  autoHideDuration = 6000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' }
}) {
  const icons = {
    success: <CheckCircleOutline />,
    error: <ErrorOutline />,
    info: <InfoOutlined />,
    warning: <WarningAmber />
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin} 
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{ minWidth: '300px' }}
        icon={icons[severity]} 
      >
        <Box>
          <Typography variant="subtitle2">
            {message}
          </Typography>
          {description && (
            <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9}}>
              {description}
            </Typography>
          )}
        </Box>
      </Alert>
    </Snackbar>
  );
}

export default NotificationSnackbar; 